import { getEnvVar } from "./envVars";

export const constants = {
  API_URL: getEnvVar("{API_URL}"),
  AUTH_URL: getEnvVar("{AUTH_URL}"),
  AUTH_REALM: getEnvVar("{AUTH_REALM}"),
  AUTH_CLIENT: getEnvVar("{AUTH_CLIENT}"),
  AUTH_CLIENT_SECRET: getEnvVar("{AUTH_CLIENT_SECRET}"),
  FIWARE_URL: getEnvVar("{FIWARE_URL}"),
  SENSING_SERVICES_URL: getEnvVar("{SENSING_SERVICES_URL}"),
  FIWARE_DRONE_ENTITY: getEnvVar("{FIWARE_DRONE_ENTITY}"),
};
